import { render } from "./FetchTh.vue?vue&type=template&id=0116e1d2&scoped=true"
import script from "./FetchTh.vue?vue&type=script&lang=js"
export * from "./FetchTh.vue?vue&type=script&lang=js"

import "./FetchTh.vue?vue&type=style&index=0&id=0116e1d2&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0116e1d2"]])

export default __exports__